import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import { TableCell } from '../Table';
import type {
  CompareModelsModalVariant,
  CompareModelsTableHeaderVAlign,
} from './types';

export interface CompareModelsTableHeaderProps {
  readonly className?: string | undefined;
  readonly isLastRow: boolean;
  readonly label?: MessageKey | undefined;
  readonly labelClassName?: string | undefined;
  readonly variant?: CompareModelsModalVariant;
  readonly verticalAlign: CompareModelsTableHeaderVAlign;
}

const CompareModelsTableHeader = ({
  className,
  isLastRow,
  label,
  labelClassName,
  variant = { md: 'two_column', lg: 'three_column' },
  verticalAlign,
}: CompareModelsTableHeaderProps) => {
  const t = useTranslations();
  const isThreeColMd = variant.md === 'three_column';
  const isThreeColLg = variant.lg === 'three_column';

  return (
    <TableCell
      className={cx(
        'w-full',
        {
          'md:flex md:w-1/4 md:max-w-60': isThreeColMd,
          'md:items-start': isThreeColMd && verticalAlign === 'top',
          'md:items-center': isThreeColMd && verticalAlign === 'center',
          'md:border-b md:border-gray-300 md:pb-6': isThreeColMd && !isLastRow,
          'lg:flex lg:w-1/4 lg:max-w-60': isThreeColLg,
          'lg:items-start': isThreeColLg && verticalAlign === 'top',
          'lg:items-center': isThreeColLg && verticalAlign === 'center',
          'lg:border-b lg:border-gray-300 lg:pb-6': isThreeColLg && !isLastRow,
        },
        className,
      )}
      data-cy="compare-models-table-header"
      Element="th"
    >
      {label && (
        <Typography
          className={cx('tracking-tight', labelClassName)}
          Element="span"
          weight="bold"
        >
          {t(label)}
        </Typography>
      )}
    </TableCell>
  );
};

export default CompareModelsTableHeader;
